module.exports = __webpack_public_path__ + "img/267-plus.821e1b96.svg";